"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.breakpointMap = exports.MEMBERS_LIST_EXPANDED = exports.MEMBERS_LIST_SUPER_COMPACT = exports.MEMBERS_LIST_COMPACT = exports.EXPANDED_MAX_ACTOR_DISPLAY = exports.SUPER_COMPACT_MAX_ACTOR_DISPLAY = exports.COMPACT_MAX_ACTOR_DISPLAY = void 0;
exports.COMPACT_MAX_ACTOR_DISPLAY = 4;
exports.SUPER_COMPACT_MAX_ACTOR_DISPLAY = 2;
exports.EXPANDED_MAX_ACTOR_DISPLAY = 6;
exports.MEMBERS_LIST_COMPACT = 'compact';
exports.MEMBERS_LIST_SUPER_COMPACT = 'super-compact';
exports.MEMBERS_LIST_EXPANDED = 'expanded';
exports.breakpointMap = {
    [exports.MEMBERS_LIST_SUPER_COMPACT]: {
        numberOfActors: exports.SUPER_COMPACT_MAX_ACTOR_DISPLAY,
    },
    [exports.MEMBERS_LIST_COMPACT]: {
        numberOfActors: exports.COMPACT_MAX_ACTOR_DISPLAY,
    },
    [exports.MEMBERS_LIST_EXPANDED]: {
        numberOfActors: exports.EXPANDED_MAX_ACTOR_DISPLAY,
    },
};
//# sourceMappingURL=Subscription.js.map